var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.136719,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#111116"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_164_2316)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3194 9.01172C10.3895 9.01172 9.63687 9.76573 9.63672 10.6935C9.63672 11.6222 10.3894 12.376 11.3195 12.376C12.2472 12.376 13.0009 11.6222 13.0009 10.6935C13.0009 9.76558 12.247 9.01172 11.3194 9.01172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.86719 13.6523H12.7687V22.9878H9.86719V13.6523Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1569 13.4219C18.7455 13.4219 17.799 14.1957 17.4117 14.9296H17.3728V13.654H14.59H14.5898V22.9893H17.4888V18.3711C17.4888 17.1536 17.7207 15.9743 19.2302 15.9743C20.718 15.9743 20.7379 17.3667 20.7379 18.4491V22.9891H23.6373V17.8687C23.6373 15.3553 23.095 13.4219 20.1569 13.4219Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_164_2316"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(9.63672 9)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLinkedin);
export default __webpack_public_path__ + "static/media/ico-linkedin.c2be1342910203541e69bd0e83bf087d.svg";
export { ForwardRef as ReactComponent };